export default __webpack_public_path__ + "static/media/hold.be79584f.svg";